import Vue from 'vue';
import { pageScroll } from 'utils/assist';
import loading from './loading.vue';

const LoadingConstructor = Vue.extend(loading);

const instance = new LoadingConstructor({
  el: document.createElement('div')
});

LoadingConstructor.prototype.show = (title = "加载中...", type) => {
  instance.title = title;
  instance.type = type || 1;
  document.body.appendChild(instance.$el);

  pageScroll.lock();
};

LoadingConstructor.prototype.hide = function() {
  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);

  pageScroll.unlock();
};

export default {
  show: instance.show,
  hide: instance.hide
};
